import { Injectable } from '@angular/core';
import { FreqInfo } from '../models/didattica/frequinfo';
import { Recupero } from '../models/recupero';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Studente } from '../models/didattica/studente';
import { AttivitaReale } from '../models/didattica/attivita-reale';
import { Observable, catchError, map, of } from 'rxjs';
import { RilevazionePresenzeService } from './rilevazione-presenze-service';

/**
 * Il servizio core della rilevazione presenze
 */
@Injectable( { providedIn: 'root' })
export class RecuperoService {

    constructor(public http: HttpClient,
      private rilevazionePresenzeService: RilevazionePresenzeService) {
        console.log('Hello RecuperoService Provider');
      }

  optionsContJson = {headers: new HttpHeaders({'Content-Type':  'application/json'})};

  richiediRecuperi(stud: Studente, mods: AttivitaReale[], freqinfos: FreqInfo[]): Observable<Recupero[]> {

    const mods_: AttivitaReale[] = [];
    for (let i = 0; i < mods.length; i++) {
      // riduzione del payload al minimo necessario: l'ar contiene tantissime informazioni del tutto inutili per il servizio da invocare
      const mod: AttivitaReale = {
        descrizione: '',
        cds: [],
        id : mods[i].id,
        idDocente: mods[i].idDocente,
        annoAccademico: mods[i].annoAccademico
      };
      mods_.push(mod);
    }

    const p: any =  {
      moduli: mods_,
      freqInfos: freqinfos
    };
    const ps = JSON.stringify(p);

    return this.http.put<Recupero[]>(`recuperi/${stud.id}/multiple`, ps, this.optionsContJson)
          .pipe(
            map(r => this.parseRecuperiResponse(r)));
  }

  getRecuperi(anno: string): Observable<Recupero[]> {
    return this.http.get(`recuperi/${anno}`)
      .pipe(map(r => this.parseRecuperiResponse(r)),
        catchError(error => {
        console.log('error in getRecuperi', error);
        return of(undefined);
    }));
  }


  getRecuperiStudente(idStudente: string, anno: string): Observable<Recupero[]> {
    return this.http.get(`recuperi/${idStudente}/${anno}`)
      .pipe(map(r => this.parseRecuperiResponse(r)),
        catchError(error => {
        console.log('error in getRecuperiStudente', error);
        return of(undefined);
    }));
  }

  salvaRecupero(recupero: Recupero): Observable<Recupero> {
    return this.http.put<Recupero>(`recuperi`, JSON.stringify(recupero), this.optionsContJson)
          .pipe(
            map(r => this.parseRecuperiResponse(r).pop()));
  }

  getConvalide(ar: AttivitaReale) {
    const idAr = ar.id.split(':')[1];
    return this.http.get(`recuperi/convalidati/${idAr}`)
       .pipe(map(r => this.parseRecuperiResponse(r))
    );

  }



  private parseRecuperiResponse(response: any): Recupero[] {

    if (response instanceof HttpErrorResponse) {
        throw response;
    } else {
        const json = response;
        if (json) {
          const data: Recupero[] = (Array.isArray(json)) ? json : Array.of(json);
          this.toRecuperoSmart(data);
          console.log('data', data);
          return data;
        }
    }
  }

  /**
   * aggiunge l'implementazione dei metodi di business
   */
  public toRecuperoSmart(recuperi: Recupero[]) {
    for (const r of recuperi) {
      if (r.docenteFrequenza) {
        this.rilevazionePresenzeService.toDocenteSmart(r.docenteFrequenza, true);
      }
      if (r.docenteConvalida) {
        this.rilevazionePresenzeService.toDocenteSmart(r.docenteConvalida, true);
      }
    }
  }

}
